import React, { useCallback, useState } from 'react'
import { Main, MainBody, MainTop, MainTopTitle, MainTopLeft } from '@/components/Layout'
import Resx from '@/components/Resx'
import context from '@/context'
import { BooleanColumn, BsrsGrid, Column, commandColumnProps } from '@/components/BsrsGrid'
import { useLocalization } from '@/hooks/localization'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import moment from 'moment'
import { Button } from '@/components/button'
import Icon from '@/components/Icon'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { getStore } from '@/store'
import { dialogTypes } from '@/dialogs'

function QlikDimensionsList (props) {
  const { localize } = useLocalization()
  const isGranted = usePermissionChecker()
  const [lastReloadedAt, setLastReloadedAt] = useState(moment())

  const canEdit = isGranted('CanManageQlikDimensions')

  const openEditDialog = useCallback((apiCall, item) => getStore().dispatch(dialogActions.openDialog({
    dialogType: dialogTypes.editDimension,
    item: item,
    onAction: newItem => apiCall(newItem).then(setTimeout(() => setLastReloadedAt(moment()), 500))
  })), [])

  const onAddClick = useCallback(() => openEditDialog(context.api.qlikDimensionsService.createDimension, { isActive: true }),
    [openEditDialog])

  const onDelete = useCallback(x =>
    context.api.qlikDimensionsService.deleteDimension(x.id).then(() => setLastReloadedAt(moment())), [])

  const dataSourceRequest = useCallback((request) => {
    return context.api.qlikDimensionsService.getDimensionsList(request, true)
  }, [])

  return <Main>
    <MainTop>
      <MainTopTitle><Resx name='Common.QlikDimensionsPageTitle' /></MainTopTitle>
      {canEdit && <MainTopLeft>
        <Button color='primary' className='btn btn-md' onClick={onAddClick}>
          <Icon name='plus' />
          <Resx name={'Common.Add'} />
        </Button>
      </MainTopLeft>}
    </MainTop>
    <MainBody>
      <BsrsGrid lastReloadedAt={lastReloadedAt} defaultSort={[{ field: 'id', dir: 'asc' }]} dataSource={dataSourceRequest}>
        <Column field='id' title={localize('Common.Id')} editable={false} filter='numeric' />
        <Column field='name' title={localize('Common.Name')} editable={false} />
        <Column field='latinName' title={localize('Common.LatinName')} editable={false} />
        <Column field='code' title={localize('Common.Code')} editable={false} />
        {BooleanColumn({ field: 'isActive', title: localize('Common.IsActive'), editable: false })}
        <Column {...commandColumnProps({
          detailUrl: x => `/dimensions-qlik-detail/${x.id}`,
          deleteAction: onDelete,
          deleteDisabled: x => !(x.reportDimensionItemsCount === 0 && canEdit),
          editAction: x => openEditDialog(context.api.qlikDimensionsService.updateDimension, x),
          editDisabled: !canEdit
        })} title=' ' width={150} />
      </BsrsGrid>
    </MainBody>
  </Main>
}

export { QlikDimensionsList }



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/qlik-dimensions/index.js